export enum OrganizationFeatures {
  CRM = 'crm',
  SUB_FARMERS_MANAGEMENT = 'subFarmersManagement',
}
